(() => {
  const animations = new WeakMap();
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.verynov-review-link');
    if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
      const reviews = document.querySelector('[data-customer-reviews]');
      if (reviews) {
        event.preventDefault();
        reviews.focus({ preventScroll: true });
        reviews.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
      }
      return;
    }
    const summary = event.target.closest('.verynov-faq summary, .vn-purchase-details summary');
    if (!summary) return;
    const details = summary.parentElement;
    if (!details.matches('[data-faq-details]')) return;
    event.preventDefault();
    const previous = animations.get(details);
    const opening = previous ? !previous.opening : !details.open;
    const from = details.getBoundingClientRect().height;
    if (previous) previous.animation.cancel();
    summary.setAttribute('aria-expanded', String(opening));
    if (reducedMotion() || !details.animate) {
      details.open = opening;
      details.style.overflow = '';
      animations.delete(details);
      return;
    }
    details.open = true;
    const to = opening ? details.scrollHeight : summary.getBoundingClientRect().height;
    details.style.overflow = 'hidden';
    const animation = details.animate([{height:from+'px'}, {height:to+'px'}], {
      duration: opening ? 380 : 280, easing:'cubic-bezier(.22,1,.36,1)'
    });
    const state = {animation, opening};
    animations.set(details, state);
    animation.onfinish = () => {
      if (animations.get(details) !== state) return;
      details.open = opening;
      details.style.overflow = '';
      animations.delete(details);
    };
  });
})();

/* Three short testimonials rotate automatically without scroll controls. */
(() => {
  const initMiniReviews = () => {
    document.querySelectorAll('[data-vn-mini-reviews]').forEach((root) => {
      if (root.dataset.vnReviewsInitialized === 'true') return;
      const slides = Array.from(root.querySelectorAll('[data-review-slide]'));
      if (slides.length < 2) return;
      root.dataset.vnReviewsInitialized = 'true';
      let active = slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (active < 0) active = 0;
      const show = (next) => {
        slides.forEach((slide, index) => slide.classList.toggle('is-active', index === next));
        active = next;
      };
      show(active);
      window.setInterval(() => show((active + 1) % slides.length), 3000);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMiniReviews, { once: true });
  } else {
    initMiniReviews();
  }
  document.addEventListener('shopify:section:load', initMiniReviews);
})();
